// extracted by mini-css-extract-plugin
export default {"wrapper":"Attachment_wrapper__LH0UO","wrapperMargins":"Attachment_wrapperMargins__828-9","props":"Attachment_props__SnIwB","extension":"Attachment_extension__vCXA9"};